/* eslint-disable */
import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const DevSprintArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);

  // =========================
  // Evolvelab Dev Sprint Content
  // =========================
  const outcomes = [
    "Clear product vision & scope",
    "Defined target customer and core problem",
    "Documented innovation & differentiation",
    "AI & technology strategy (where it actually adds value)",
    "Build-ready product documentation (VRD / BRD / FRD)",
    "Phased product roadmap (MVP → V1 → V2)",
    "Funding- and grant-ready product narrative",
    "Execution readiness: sprint plan + dev approach",
  ];

  const forWho = [
    "Founders with an idea but no clear product definition",
    "Startups stuck before development or MVP",
    "Teams unsure what to build first",
    "AI-first or innovation-driven products needing clarity",
    "Companies preparing for build, funding, grants, or accelerators",
  ];

  const problem = [
    "The problem isn’t clearly defined",
    "Product-market fit is assumed, not tested",
    "AI is added without purpose",
    "Features are unclear or bloated",
    "Developers are given vague instructions",
  ];

  const deliverablesLeft = [
    "Customer & problem definition",
    "Target users & personas",
    "Success metrics & constraints",
    "Product positioning & differentiation",
    "Product-market fit hypotheses",
    "AI & advanced technology use-case definition",
  ];

  const deliverablesRight = [
    "Product architecture & modular breakdown",
    "Epics, features & dependencies",
    "VRD, BRD, FRD documentation",
    "Product backlog (epics & user stories)",
    "Phased roadmap & sprint plan",
    "Funding, grant & accelerator-ready narrative",
  ];

  const whyChoose = [
    "We combine product, technology, AI, and funding thinking",
    "We reduce costly rework and wrong builds",
    "We align founders, teams, and stakeholders",
    "We produce documentation developers can actually use",
    "We prepare you for Build, Fund Jumpstart, or Fund Boost",
  ];

  const notIncluded = [
    "Software development or coding",
    "UI/UX design execution",
    "Engineering implementation",
  ];

  const afterProgram = [
    "Build-ready product documentation",
    "Clear MVP definition",
    "Prioritized feature backlog",
    "Technical & AI strategy",
    "Product roadmap & sprint plan",
    "Funding-ready product story",
    "No more ambiguity. No more guesswork.",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Funding Program
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                                    <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                                    <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                                  </ul>
                
                                  <div style={{ height: '16px' }}></div>
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Dev Accelerator
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                                    <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                                    <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                                  </ul>
                                </div>

                <div className="widget widget_author text-center">
                  
                  <div className="details">
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                      onClick={() => setShowMeetings((s) => !s)}
                    >
                      Book a Free Sprint Discovery Call +
                    </button>

                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="/assets/pdf/Evolvelab_Sprint.pdf"
                        style={{ color: "#000000" }}
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Download the Sprint Overview{" "}
                        <FaAngleDoubleRight
                          style={{ background: "rgba(170, 237, 222, 1)" }}
                          onMouseEnter={(e) => (e.target.style.background = "#50af9b")}
                          onMouseLeave={(e) =>
                            (e.target.style.background = "rgba(170, 237, 222, 1)")
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Dev Sprint Snapshot
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Fixed Fee: CAD $5,000
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Timeline: 4 weeks
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Delivery: Hands-on sprint
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Note: No coding included
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO IMAGE with VIDEO BACKGROUND */}
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                      margin: 0,
                    }}
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    >
                      <source src="/assets/video/sprint.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div
                    className="details"
                    style={{ position: "relative", zIndex: 1, padding: "50px" }}
                  >
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Dev Sprint (EvolveSprint)</p>
                    <h1>From Idea to Build-Ready Product — in 4 Weeks</h1>

                    <p className="mb-2">
                      Stop debating your product.
                      <br />
                      Start moving toward execution.
                    </p>

                    <p>
                      Evolvelab Dev Sprint is a 4-week intensive product and strategy sprint designed
                      to take founders from idea or fuzzy concept to a clear, build-ready, fundable
                      product plan.
                    </p>

                    <p><b>No theory. No endless workshops. Real clarity, real documentation, real momentum.</b></p>

                    {/* KEY OUTCOME LIST */}
                    <h5 className="mt-4">What you get by the end of 4 weeks:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHO IT'S FOR */}
                    <h4>Who the Dev Sprint Is For</h4>
                    <p>Evolvelab Dev Sprint is ideal for:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>
                      <b>If you’re about to spend money on development — this sprint saves you from building the wrong thing.</b>
                    </p>

                    {/* PROBLEM */}
                    <h4>The Problem We Solve</h4>
                    <p>Most startups fail before development even starts because:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {problem.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>Dev Sprint removes ambiguity before you build.</b></p>

                    {/* WHAT YOU GET */}
                    <h4>What You Get in 4 Weeks</h4>
                    <p>This is a done-with-you execution sprint, not advice.</p>

                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <p><b>You leave knowing exactly what to build, why, and how.</b></p>

                    {/* HOW IT WORKS */}
                    <h4 id="how-it-works">How the 4-Week Dev Sprint Works</h4>

                    <h6 className="mt-3">Week 1 — Product Clarity</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Customer & problem definition</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Target users & personas</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Success metrics & constraints</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Founder vision alignment</li>
                    </ul>

                    <h6>Week 2 — Strategy & Innovation</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Product positioning & differentiation</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Product-market fit hypotheses</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> AI & advanced technology use-case definition</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Validation strategy</li>
                    </ul>

                    <h6>Week 3 — Build-Ready Planning</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Product architecture & modular breakdown</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Epics, features & dependencies</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> VRD, BRD, FRD documentation</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Product backlog (epics & user stories)</li>
                    </ul>

                    <h6>Week 4 — Execution Readiness</h6>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Phased roadmap & sprint plan</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Development approach (build / buy / partner)</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Commercialization & GTM direction</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Funding, grant & accelerator-ready narrative</li>
                    </ul>

                    {/* WHY CHOOSE */}
                    <h4>Why Founders Choose Evolvelab Dev Sprint</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>This sprint becomes the foundation for everything that follows.</b></p>

                    {/* PRICING */}
                    <h4 id="pricing">Pricing & Timeline</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Fixed Fee: <b>CAD $5,000</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Timeline: <b>4 weeks</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Delivery: <b>Hands-on, founder-involved sprint</b></li>
                    </ul>
                    <p>
                      <b>Note:</b> This sprint does not include actual software development or coding. It ensures development starts right.
                    </p>

                    {/* NOT INCLUDED */}
                    <h4>What the Dev Sprint Is Not</h4>
                    <p>To stay focused, this engagement does not include:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>(Those come after clarity — and we can support them next.)</p>

                    {/* OUTCOME */}
                    <h4>The Result</h4>
                    <p>After Evolvelab Dev Sprint, you’re no longer “thinking about building.”</p>
                    <p><b>You’re ready to execute — with confidence, alignment, and a plan.</b></p>

                    <h5 className="mt-3">What you’ll walk away with:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {afterProgram.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* FINAL CTA */}
                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Free Sprint Discovery Call
                      </button>

                     

                      <Link className="btn btn-black border-radius-5" to="/apply">
                        🚀 Apply for Evolvelab Dev Sprint
                      </Link>
                    </div>

                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default DevSprintArea;